import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BatchEditDialogComponent } from '../batch-edit-dialog/batch-edit-dialog.component';

@Component({
    selector: 'app-batch-list',
    templateUrl: './batch-list.component.html',
    styleUrls: ['./batch-list.component.scss'],
    standalone: false,
})
export class BatchListComponent implements OnInit {
    batches: any[] = [];
    reviewOnly = false;
    generalFund: any[] = [];
    dataSource: any[] = [];
    showAll = false;
    canSeePledges: any;
    pledgeAccountId = 155;

    @ViewChild('batchesGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        await this.getData();
        this.reviewOnly = this.appInfo.graafschap && this.auth.hasRole('Secretary');
    }
    async getData() {
        this.appInfo.pleaseWaitShow();
        let batches = (await this.uow.getBatchList(this.showAll ? null : 100)) as any;
        this.canSeePledges = this.auth.hasRole('Pledges') || this.auth.hasRole('Administrator');
        if (!this.canSeePledges) {
            batches = batches.filter((x) => {
                return x.specialAccountId !== this.pledgeAccountId;
            });
        }

        this.batches = batches;
        this.appInfo.pleaseWaitHide();
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    add() {
        const modalRef = this.modalService.show(BatchEditDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { routerOption: 'new' },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
                this.open(result.batchId);
                this.dataGrid.instance.refresh();
            }
        });
    }

    onRowPrepare(e) {
        if (e.rowType === 'data') {
            if (e.data.statusName === 'Error') e.rowElement.className = e.rowElement.className + ' batch-error-grid';
            if (e.data.statusName === 'Review') e.rowElement.className = e.rowElement.className + ' batch-review-grid';
            if (e.data.statusName !== 'Error' && e.data.statusName !== 'Review' && e.data.notes > 0) e.rowElement.className = e.rowElement.className + ' batch-notes-grid';
        }
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data.id);
    }

    async open(batchId: number) {
        if (!batchId) return;
        if (batchId) this.router.navigate(['/giving/batches/' + batchId]);
    }

    async printDepositSlips() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const ids = selectedRows.map(x => {return x.id})
        console.log(selectedRows);
        const result = await this.utility.bankDepositSlips(ids);
    }
}
